module.exports = __webpack_public_path__ + "img/outside.f130fb0f.jpg";